import { GeomTools } from 'src/app/shared/services/geom-tools';
import { NavParams } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { DiagDiagnosticService } from 'src/app/service/diag-diagnostic.service';

@Component({
  selector: 'app-synchrophoto',
  templateUrl: './synchrophoto.component.html',
  styleUrls: ['./synchrophoto.component.scss'],
})

export class SynchrophotoComponent implements OnInit {

  idDiag: number;
  imagesrc: any;
  imgheight: any;
  imgwidth: any;
  profilImagesrc: any;
  data = [];
  data1 = [];
  pt = [];
  pt2 = [];
  pointSize = 3;
  ReelradioImgWidth: any;
  ReelradioImgHeight: any;
  ReelprofilImgWidth: any;
  ReelprofilImgHeight: any;
  perwidth: any;
  perheight: any;

  constructor(
    public modalCtrl: ModalController,
    private navParams: NavParams,
    public diagdiagnostic: DiagDiagnosticService
  ) {
    this.imagesrc = this.navParams.data.imagesrc;
    this.imgheight = this.navParams.data.imgheight;
    this.imgwidth = this.navParams.data.imgwidth;
    this.profilImagesrc = this.navParams.data.profilimg;
    this.idDiag = this.navParams.data.idDiag;
  }
  ngOnInit() {
    this.RadioCanvas();
    this.ProfilCanvas();
    this.perheight = this.ReelradioImgHeight / this.ReelprofilImgHeight;
    this.perwidth = this.ReelradioImgWidth / this.ReelprofilImgWidth;
  }

  reload() {
    window.location.reload();
  }

  RadioCanvas() {
    const canvas = <HTMLCanvasElement>document.querySelector("#appRadio");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.src = this.imagesrc;
    canvas.height = 800;
    canvas.width = 800;
    img.onload = function () {
      // set size proportional to image
      //  canvas.height = canvas.width * (img.height / img.width);
      // step 1 - resize to 50%
      var oc = document.createElement("canvas"),
        octx = oc.getContext("2d");
      oc.width = canvas.width ;
      oc.height = canvas.height ;
      octx.drawImage(img, 0, 0, (img.width*canvas.width/img.height), oc.height);
      // step 2
      octx.drawImage(oc, 0, 0, oc.width , oc.height );
      // step 3, resize to final size
      ctx.drawImage(
        oc,
        0,
        0,
        oc.width ,
        oc.height ,
        0,
        0,
        canvas.width,
        canvas.height
      );
    };
  }
  getPosition(event) {
    const canvas = <HTMLCanvasElement>document.querySelector("#appRadio");
    const ctx = canvas.getContext("2d");
    let curleft = 0,
      curtop = 0;
    var id = 0;
    curleft += event.offsetX;
    curtop += event.offsetY;
    if (this.data.length > 0) {
      id = this.data[this.data.length - 1].id + 1;
    }
    var p = { pt: id, x: curleft, y: curtop };
    this.data.push(p);
    if (this.data.length <= 2) {
      this.draw(this.data);
      this.pt.push({ curleft, curtop });
      //console.log(this.pt);
    } else {
      alert("you draw all point");
    }
    if (this.data.length == 2) {
      this.DrawExtraForms(this.data);
    }
    
  }
  draw(data) {
    for (let i = 0; i < data.length; i++) {
      this.drawcircle(data[i]);
    }
  }
  drawcircle(data) {
    const canvas = <HTMLCanvasElement>document.querySelector("#appRadio");
    const ctx = canvas.getContext("2d");
    const grd = ctx.createLinearGradient(0, 0, 170, 0);
    grd.addColorStop(0, "red");
    ctx.fillStyle = grd; // Red color
    ctx.strokeStyle = grd;
    ctx.beginPath();
    ctx.arc(
      Number(data.x),
      Number(data.y),
      this.pointSize,
      0,
      Math.PI * 2,
      true
    );
    ctx.fill();
    //this.ctx.stroke();
  }
  DrawExtraForms(data): void {
    const canvas = <HTMLCanvasElement>document.querySelector("#appRadio");
    const ctx = canvas.getContext("2d");
    ctx.moveTo(data[0].x, data[0].y);
    ctx.lineTo(data[1].x, data[1].y);
    ctx.stroke();
  }
  ////////////////Profil Section/////////////
  ProfilCanvas() {
    const canvas = <HTMLCanvasElement>document.querySelector("#appProfil");
    Object.assign(canvas, { width: this.imgwidth, height: this.imgheight });
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality="high";
    const profileImage = new Image();
    profileImage.src = this.profilImagesrc;
  
    profileImage.onload = function () {
      // step 1 - resize to 50%
      var oc = document.createElement("canvas");
      var octx = oc.getContext("2d");
      oc.width = profileImage.width ;
      oc.height = profileImage.height ;
      octx.imageSmoothingQuality="high";
      octx.drawImage(profileImage, 0, 0, oc.width, oc.height);
      canvas.height = 800;
      canvas.width =  oc.width*800/oc.height; 
      // step 2
     octx.drawImage(oc, 0, 0, oc.width , oc.height );
      // step 3, resize to final size
      ctx.drawImage(
        oc,
        0,
        0,
        oc.width ,
        oc.height ,
        0,
        0,
        oc.width*800/oc.height ,
        canvas.height
      );
    };
  }

  getPosition1(event) {
    const canvas = <HTMLCanvasElement>document.querySelector("#appProfil");
    const ctx = canvas.getContext("2d");
    let curleft = 0,
      curtop = 0;
    var id = 0;
    curleft += event.offsetX;
    curtop += event.offsetY;
    if (this.data1.length > 0) {
      id = this.data1[this.data1.length - 1].id + 1;
    }
    var pts = { id: id, x: curleft, y: curtop };
    this.data1.push(pts);
    if (this.data1.length <= 2) {
      this.draw1(this.data1);
      this.pt2.push({ curleft, curtop });
    } else {
      alert("you draw all point");
    }
    if (this.data1.length == 2) {
      this.DrawExtraForms1(this.data1);
    }
  }
  draw1(data) {
    for (let i = 0; i < data.length; i++) {
      this.drawcircle1(data[i]);
    }
  }
  drawcircle1(data) {
    const canvas = <HTMLCanvasElement>document.querySelector("#appProfil");
    const ctx = canvas.getContext("2d");
    const grd = ctx.createLinearGradient(0, 0, 170, 0);
    grd.addColorStop(0, "red");
    ctx.fillStyle = grd; // Red color
    ctx.strokeStyle = grd;
    ctx.beginPath();
    ctx.arc(
      Number(data.x),
      Number(data.y),
      this.pointSize,
      0,
      Math.PI * 2,
      true
    );
    ctx.fill();
  }
  DrawExtraForms1(data): void {
    const canvas = <HTMLCanvasElement>document.querySelector("#appProfil");
    const ctx = canvas.getContext("2d");
    ctx.moveTo(data[0].x, data[0].y);
    ctx.lineTo(data[1].x, data[1].y);
    ctx.stroke();
  }

  syncroobj = {
    syncro_x: 0,
    syncro_y: 0,
    syncro_zoom: 0,
    syncro_rotation: 0,
  };

  async sendData() {
    if(typeof this.pt[1] === 'undefined' || typeof this.pt2[1] === 'undefined') {
      alert("Veuillez finir de tracer les points.");
      return;
    }

    const d1 = this.Distance(
      this.pt[0].curleft,
      this.pt[0].curtop,
      this.pt[1].curleft,
      this.pt[1].curtop
    );
    const d2 = this.Distance(
      this.pt2[0].curleft,
      this.pt2[0].curtop,
      this.pt2[1].curleft,
      this.pt2[1].curtop
    );
    const scale = d1/d2;
   
    let a = this.pt2[1].curleft - this.pt2[0].curleft;
    let b = this.pt2[1].curtop - this.pt2[0].curtop;
    let c = this.pt[1].curleft - this.pt[0].curleft;
    let d = this.pt[1].curtop - this.pt[0].curtop;
    let atanA = Math.atan2(a, b);
    let atanB = Math.atan2(c, d);

    let angleRad = atanA - atanB;

    var x = this.pt2[0].curleft;
    var y = this.pt2[0].curtop;

    var x2 = this.pt2[1].curleft;
    var y2 = this.pt2[1].curtop;

    var __x = (this.pt[0].curleft * Math.cos(-angleRad)) - (this.pt[0].curtop * Math.sin(-angleRad));
    var __y = (this.pt[0].curtop * Math.cos(-angleRad)) + (this.pt[0].curleft * Math.sin(-angleRad));
    
    var __x2 = (this.pt[1].curleft * Math.cos(-angleRad)) - (this.pt[1].curtop * Math.sin(-angleRad));
    var __y2 = (this.pt[1].curtop * Math.cos(-angleRad)) + (this.pt[1].curleft * Math.sin(-angleRad));

    var xi = ( x + x2 ) / 2;
    var yi = ( y + y2 ) / 2;

    var __xi = ( __x + __x2 ) / 2;
    var __yi = ( __y + __y2 ) / 2;
      
    this.diagdiagnostic.updateSynchro(this.idDiag, xi, yi, __xi, __yi, scale, angleRad).subscribe(
      (data: any) => {
        console.log(data);
        this.closeAllModal();
      }
    );

  }
  
  closeAllModal() {
    this.modalCtrl.dismiss();
  }

  sqr(a) {
    return a * a;
  }
  Distance(x1, y1, x2, y2) {
    return Math.sqrt(this.sqr(y2 - y1) + this.sqr(x2 - x1));
  }

}
